// Central SEO config and helpers

export const SITE_NAME = 'Calcium';
export const DEFAULT_TITLE = 'Calcium — fitness, your way.';
export const DEFAULT_DESCRIPTION =
  'Calcium helps you create, track, and share fitness routines. Generate AI-powered workouts, explore community stryds, and stay consistent with meals and challenges.';

export function getSiteUrl() {
  // Prefer explicit env; otherwise fall back to runtime origin; final fallback is public domain
  const envUrl = process.env.REACT_APP_SITE_URL;
  if (envUrl && /^https?:\/\//i.test(envUrl)) return envUrl.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  // Reasonable default based on branding
  return 'https://calcium.fitness';
}

export function absoluteUrl(path = '/') {
  const base = getSiteUrl();
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${base}${clean}`;
}
